import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from "axios";
import {getCookie, setCookie} from "../../utils/cookie";
import logoutAndRedirect from "../../utils/logoutAndRedirect";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API;

export interface ResetResult {
    data: any[];
}

export const updateDetailsApi = createAsyncThunk(
    'users/profile',
    async (account: any, { rejectWithValue }) => {
        const {id} = getCookie('auth')
        const updateURL = `${URL_API}/supplier-portal/details/${id}`;

        try {
            const { data } = await axios.put<ResetResult>(updateURL, account, {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                }
            });

            if (data) {
                setCookie('auth', data.data);
            }

                return data;
        } catch (error) {

            // @ts-ignore
            if(error.response.status === 401){
                logoutAndRedirect('/sign-in')
            }

            // @ts-ignore
            return rejectWithValue(error.response.data)
        }
    }
);